<template>
  <div>
    <Header page="request"/>
    <b-container>
      <div class="d-flex justify-content-center mt-34">
        <div class="w-100 mw-800">
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">お名前</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">
                <span v-if="!displayFields.name">{{detailRequest.name}}</span>
                <b-form-input v-if="displayFields.name" v-model="detailRequest.name" e-else class="input-form item-input" />
                <div class="request-actions">
                  <div class="edit-action text-info" @click="displayFields.name = !displayFields.name">
                    <i class="icon-i-edit"></i>
                    <i class="icon-i-times"></i>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">要件</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">
                <span>{{detailRequest.requirement}}</span>
              </div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">会社名</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">
                <span v-if="!displayFields.company_name">{{detailRequest.company_name}}</span>
                <b-form-input v-if="displayFields.company_name" v-model="detailRequest.company_name" e-else class="input-form item-input" />
                <div class="request-actions">
                  <div class="edit-action text-info" @click="displayFields.company_name = !displayFields.company_name">
                    <i class="icon-i-edit"></i>
                    <i class="icon-i-times"></i>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">メール</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">
                <span v-if="!displayFields.email">{{detailRequest.email}}</span>
                <b-form-input v-if="displayFields.email" v-model="detailRequest.email" e-else class="input-form item-input" />
                <div class="request-actions">
                  <div class="edit-action text-info" @click="displayFields.email = !displayFields.email">
                    <i class="icon-i-edit"></i>
                    <i class="icon-i-times"></i>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">電話番号</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">
                <span v-if="!displayFields.phone">{{detailRequest.phone}}</span>
                <b-form-input v-if="displayFields.phone" v-model="detailRequest.phone" e-else class="input-form item-input" />
                <div class="request-actions">
                  <div class="edit-action text-info" @click="displayFields.phone = !displayFields.phone">
                    <i class="icon-i-edit"></i>
                    <i class="icon-i-times"></i>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="infor-row border-0">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">内容</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor vendor-content-infor-long">{{detailRequest.content}}</div>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center mt-50" @click="addCompany">
            <button class="btn btn-createAccount btn-rounder">
              <span>業者作成</span>
            </button>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
export default {
  name: 'Detail',
  components: {
    Header
  },
  computed: {
    ...mapState({
      detailRequest: state => state.adminRequest.detailRequest
    })
  },
  data () {
    return {
      displayFields: {
        company_name: false,
        name: false,
        phone: false,
        email: false
      }
    }
  },
  methods: {
    addCompany () {
      const params = {
        company_name: this.detailRequest.company_name,
        representative_name: this.detailRequest.name,
        representative_phone: this.detailRequest.phone,
        representative_email: this.detailRequest.email
      }
      this.$store.dispatch('adminRequest/createCompany', {formData: params, id: this.$route.params.id})
    }
  },
  mounted () {
    this.$store.dispatch('adminRequest/getDetailRequest', this.$route.params.id)
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/stylesheet/admin/request.scss';
@import "@/assets/stylesheet/admin/vendor.scss";
.tdVendor-differ {
  border-bottom: 0;
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Request/Detail.vue